import { render, staticRenderFns } from "./jobs_container.vue?vue&type=template&id=2874b597&"
import script from "./jobs_container.vue?vue&type=script&lang=js&"
export * from "./jobs_container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports